//export const BASE_URL = 'http://localhost:8080/capufe-quadrum-backend/';
//export const BASE_URL = 'https://quadrumdesarrollo.com.mx/capufe-quadrum-backend/';
export const BASE_URL = 'https://facturacioncapufe.com.mx/capufe-quadrum-backend/';
export const TOKEN_CAPUFE="TokenCapufe";
export const TOKEN_BROWSER="TokenBrowserCapufe";
export const USUARIO_KEY="UserCapufe"
export const BEARER="Bearer ";
export const BASE_URL_TIMBRADOV40="https://quadrumdesarrollo.com.mx/timbradocfdi40/";
export const BASIC_USUARIO_CONTRASENA="Basic dmFsaWRhZG9yOlZhbGlkYWRvcjFTMiM=";

export const CALENDARIO_ES_MX = {
    firstDayOfWeek: 1,
    dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
    dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
    dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
    monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
    monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
    today: "Hoy",
    clear: "Limpiar"
};



